import React from 'react'

// Heartbeat-based health from the dashboard (classifyBotHealth in
// server/routes/audiosocket-bots.js). Hover shows the reason.
const HEALTH_STYLE = {
    healthy:      { label: 'Healthy',      color: '#22c55e' },
    starting:     { label: 'Starting',     color: '#60a5fa' },
    degraded:     { label: 'Degraded',     color: '#f59e0b' },
    stuck:        { label: 'Stuck',        color: '#ef4444' },
    offline:      { label: 'Offline',      color: '#ef4444' },
    stopped:      { label: 'Stopped',      color: '#6b7280' },
    no_heartbeat: { label: 'No heartbeat', color: '#6b7280' },
}
export default function HealthBadge({ health, version }) {
    if (!health) return <span style={{ fontSize: 11, opacity: 0.4 }}>—</span>
    const st = HEALTH_STYLE[health.state] || { label: health.state, color: '#9ca3af' }
    const tip = [health.reason, version ? `bot ${version}` : null, health.outdated ? 'outdated — redeploy bot code' : null]
        .filter(Boolean).join(' · ')
    return (
        <span title={tip} style={{ display: 'inline-flex', alignItems: 'center', gap: 5, whiteSpace: 'nowrap' }}>
            <span style={{
                fontSize: 11, fontWeight: 600, padding: '1px 7px', borderRadius: 10,
                color: st.color, border: `1px solid ${st.color}`, background: `${st.color}1a`
            }}>{st.label}</span>
            {health.outdated && <span style={{ fontSize: 10, color: '#f59e0b' }} title={tip}>outdated</span>}
        </span>
    )
}
